import React, { useState } from 'react';
import { menuItems, menuNavigationTypes } from '../../constants.js';
import { useNavigate } from "react-router-dom";

const MainMenu = (props) => {
    const navigate = useNavigate();
    const items = menuItems[props.menuType];
    const [selectedKey, setSelectedKey] = useState(props.selectedKey ? props.selectedKey : items[0]?.Key);

    const isSelectedItem = (item) => {
        if (item.Type === menuNavigationTypes.link) {
            return window.location.pathname === item.TargetUrl || window.location.pathname === item.TargetUrl + '/';
        }
        else {
            return item.Key === selectedKey;
        }
    }

    const onLinkClick = (item) => {
        if (!isSelectedItem(item)) {
            if (item.Type === menuNavigationTypes.link) {
                navigate(item.TargetUrl);
            }
            else {
                setSelectedKey(item.Key);
            }
            if (props.onTabChanged) {
                props.onTabChanged(item.Key);
            }
        }
        if (props.onTabClick) {
            props.onTabClick(item.Key);
        }
    }

    return <div className={'main-menu ' + props.menuType}>
        <div className='main-menu-items'>
            {items?.map((item) => <div key={item.Key} className={"main-menu-item" + (isSelectedItem(item) ? " selected" : "")} onClick={() => onLinkClick(item)}>
                <div className='img-contaner'>
                    <img src={item.IconUrl} />
                </div>
                <span>{item.Title}</span>
            </div>
            )}
        </div>
    </div>
}
export default MainMenu;